import React from "react";
import styled from "styled-components";
import { Input } from "antd";

import colors from "constants/palette";

const Container = styled.div`
  margin-top: 12px;
  & input,
  textarea,
  .ant-form-item-has-error
    :not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper,
  .ant-form-item-has-error
    :not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:hover,
  .ant-form-item-has-error
    :not(.ant-input-disabled):not(.ant-input-borderless).ant-input,
  .ant-form-item-has-error
    :not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover,
  .ant-form-item-has-error
    :not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper,
  .ant-form-item-has-error
    :not(.ant-input-number-affix-wrapper-disabled):not(.ant-input-number-affix-wrapper-borderless).ant-input-number-affix-wrapper:hover {
    background-color: ${colors.white + "40"} !important;
    color: ${colors.dark};
  }
`;

export function TextArea(props) {
  return (
    <Container>
      <Input.TextArea {...props} />
    </Container>
  );
}
export default function App(props) {
  return (
    <Container>
      <Input {...props} />
    </Container>
  );
}
